import RestModule from "../store/RestModule";
import schema from "./schema/index";

var root_url = process.env.VUE_APP_ROOT_API;

const GroupStateModule = RestModule(
    root_url + "/api/ocom/group_state/",
    schema.GroupState
);
const GroupStateModelFieldModule = RestModule(
    root_url + "/api/ocom/group_state_model_field/",
    schema.GroupStateModelField
);
const GroupPermissionsModule = RestModule(
    root_url + "/api/ocom/group_permissions/",
    schema.GroupPermissions
);
const GroupStateModelModule = RestModule(
    root_url + "/api/ocom/group_state_model/",
    schema.GroupStateModel
);
const PermissionModule = RestModule(
    root_url + "/api/ocom/permission/",
    schema.Permission
);
const GroupModule = RestModule(root_url + "/api/ocom/group/", schema.Group);
const UserModule = RestModule(root_url + "/api/ocom/user/", schema.User);
const ContentTypeModule = RestModule(
    root_url + "/api/ocom/content_type/",
    schema.ContentType
);

export default {
    GroupStateModule,
    GroupStateModelFieldModule,
    GroupPermissionsModule,
    GroupStateModelModule,
    PermissionModule,
    GroupModule,
    UserModule,
    ContentTypeModule,
    //Add more modules here
};
